import { useQuery } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse, CountryData, CountryDataResponse } from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'

const fetchStates = async (
  countryCode: string
): Promise<CountryData | undefined> => {
  const apiResponse = await apiAuthClient.get<CountryDataResponse>(
    endpoints.getStates({ countryCode }),
    {
      headers: {
        ...getRandomExampleHeader(
          countryCode === 'US' ? ['example-1'] : ['example-empty']
        ),
      },
      /* {
        ...getRandomExampleHeader([
          'example-empty',
          // 'empty-list',
        ]),
      }, */
    }
  )
  return apiResponse.data.data
}

export const useGetStates = (countryCode: string) =>
  useQuery<CountryData | undefined, ApiErrorResponse>(
    ['getStates', countryCode],
    () => fetchStates(countryCode),
    {
      enabled: !!countryCode,
    }
  )
